import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { thunks } from '@redux/app';
import { PaymentService } from '@services';
import { Loader } from '@components/common';
import utils from '@utils';
import CreditCardForm from '../../../components/AddPaymentMethodModal/CreditCardForm/CreditCardForm';

class PaymentForm extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			loading           : false,
			creditCardFormRef : null,
		};
	}

	setCustomRef = (ref) => {
		this.setState({ creditCardFormRef : ref });
	}

	onSubmitClick = () => {
		const { creditCardFormRef } = this.state;
		if (creditCardFormRef) creditCardFormRef.click();
	}

	submitForm = (response) => {
		const { onDone, getUser } = this.props;

		this.setState({ loading : true });

		// This form is currently used only to add the first payment card,
		// that's why the flag IsDefaultCard is added to the request
		const { token } = response;
		PaymentService.addPaymentMethod({ PaymentCard : { TokenId : token.id, IsDefaultCard : true } })
			.then(({ data }) => {
				utils.notify({
					type    : 'success',
					message : data.Message || 'Payment method added successfully',
				});

				getUser(() => {
					this.setState({ loading : false }, onDone);
				});
			}).catch(({ response : data }) => {
				utils.notify({
					type    : 'error',
					message : data.Message || 'Error adding payment method',
				});
				this.setState({ loading : false });
			});
	}

	render() {
		const { loading } = this.state;

		const {
			showDisclaimer, isModal, addButtonText, userAddress,
		} = this.props;

		return (
			<div className={isModal ? '' : 'container'}>
				<div className="row">
					<div
						id="prepay-payment-form-container"
						className={isModal ? 'col-xs-12' : 'col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3'}
					>
						<div id="form-header" className="col-xs-12">
							<h3>Enter Credit Card Details</h3>
							<img
								id="cards"
								src="/images/cardIcons/cards2x.png"
								alt="cards"
							/>
						</div>

						<div className="col-xs-12">
							<div className="separator separator-solid" />
						</div>

						<CreditCardForm
							userAddress={userAddress}
							hideButtons
							setCustomRef={this.setCustomRef}
							onSubmit={this.submitForm}
							expandAddress={!userAddress._state}
						/>

						<div className="col-xs-12">
							<div className="separator separator-solid" />
						</div>

						<If condition={showDisclaimer}>
							<div id="disclaimer-container" className="col-xs-12">
								<p>Your card will not be charged until the setup is confirmed. One of our coordinators will be in contact within 24 hours</p>
							</div>
						</If>

						<div id="submit-button-container" className="form-group col-xs-12">
							<button
								id="submit-button"
								type="submit"
								className="btn btn-primary"
								onClick={this.onSubmitClick}
							>
								{addButtonText}
							</button>
						</div>

						<Loader active={loading} />
					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	getUser : bindActionCreators(thunks, dispatch).getUser,
});

PaymentForm.propTypes = {
	userAddress    : PropTypes.object,
	showDisclaimer : PropTypes.bool,
	isModal        : PropTypes.bool,
	onDone         : PropTypes.func,
	getUser        : PropTypes.func.isRequired,
	addButtonText  : PropTypes.string,
};

PaymentForm.defaultProps = {
	userAddress    : {},
	showDisclaimer : false,
	isModal        : false,
	onDone         : () => undefined,
	addButtonText  : 'Add Payment Method',
};

export default connect(null, mapDispatchToProps)(PaymentForm);
